// extracted by mini-css-extract-plugin
export default {"header":"BaseContainer_header__Rh4Lu","search":"BaseContainer_search__VOLL-"};